var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-shifts" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "shifts-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
          },
          on: {
            shown: _vm.setTabs,
            close: function ($event) {
              _vm.active = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(" Добавить сотрудников ")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.position,
                  expression: "!position",
                },
              ],
              ref: "tabs",
              staticClass: "tabs",
            },
            [
              _c(
                "div",
                { staticClass: "tabs__wrapper" },
                [
                  _vm._l(_vm.positions, function (position) {
                    return _c(
                      "div",
                      {
                        key: position.code,
                        staticClass: "tab",
                        class: {
                          active: _vm.activePosition === position,
                        },
                        on: {
                          click: function ($event) {
                            _vm.activePosition = position
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(position.name) + " ")]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "more", on: { click: _vm.onMoreClick } },
                    [
                      _vm._v(" Еще... "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTabs,
                              expression: "showTabs",
                            },
                          ],
                          staticClass: "tabs-list",
                          style: {
                            "margin-right": -1 * _vm.moreOffset + "px",
                          },
                          attrs: { "data-offset": _vm.moreOffset },
                        },
                        [
                          _c(
                            "shadow-scroll-container",
                            { staticClass: "tabs-list__scroll" },
                            _vm._l(_vm.positions, function (position) {
                              return _c(
                                "div",
                                {
                                  key: position.code,
                                  staticClass: "tabs-list__item",
                                  class: {
                                    active: _vm.activePosition === position,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onPositionClick(position)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(position.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]
          ),
          _c(
            "shadow-scroll-container",
            { staticClass: "scroll-container" },
            [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c("c-switcher", {
                    staticClass: "all-filials",
                    attrs: { label: "Все филиалы" },
                    model: {
                      value: _vm.allFilials,
                      callback: function ($$v) {
                        _vm.allFilials = $$v
                      },
                      expression: "allFilials",
                    },
                  }),
                  _c("c-input", {
                    staticClass: "search",
                    attrs: {
                      placeholder: "Поиск по ФИО",
                      type: "text",
                      clearable: true,
                      icon: "search",
                    },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                ],
                1
              ),
              _vm.loading
                ? _c("c-loader", {
                    staticClass: "loader",
                    attrs: { active: true, height: 100 },
                  })
                : !_vm.workers.length
                ? _c("div", { staticClass: "empty" }, [
                    _vm._v("Сотрудники не найдены"),
                  ])
                : !_vm.filteredList.length
                ? _c("div", { staticClass: "empty" }, [
                    _vm._v("Сотрудники не найдены"),
                  ])
                : _c(
                    "div",
                    { staticClass: "list" },
                    _vm._l(_vm.filteredList, function (worker) {
                      return _c(
                        "div",
                        {
                          key: worker.data.id,
                          staticClass: "list-item",
                          attrs: { "data-shift": worker.data.work_shift_type },
                        },
                        [
                          _c("c-switcher", {
                            attrs: {
                              type: "checkbox",
                              label: worker.data.name,
                              value: worker.checked,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.toggleWorker(worker)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-shifts-buttons" },
            [
              _c("c-button", {
                staticClass: "reset",
                attrs: { size: "large", label: "Сбросить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass: "apply",
                attrs: { size: "large", label: "Применить", color: "blue" },
                on: { click: _vm.apply },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }